import {
  BookOpenIcon,
  ClipboardCheckIcon,
  FileTextIcon,
  ListChecksIcon,
  ScissorsIcon,
  BadgeCheckIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: BookOpenIcon,
    title: '10 Volumi Completi',
    description: 'Un volume per ogni anno scolastico, dalla 1ª primaria al 2º anno del biennio.',
  },
  {
    icon: FileTextIcon,
    title: '600 Pagine di Programma',
    description: "Teoria, esempi svolti, esercizi e verifiche per l'intero anno.",
  },
  {
    icon: ListChecksIcon,
    title: 'Guida Passo Passo',
    description: 'Cosa dire e cosa mostrare in ogni lezione, con le domande giuste da fare alla classe.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Verifiche e Soluzioni',
    description: 'Prove finali, griglie di punteggio e tutti i passaggi svolti.',
  },
  {
    icon: ScissorsIcon,
    title: 'Materiali da Ritagliare',
    description: 'Flashcard, poster A3 e formulari pronti da stampare e appendere.',
  },
  {
    icon: BadgeCheckIcon,
    title: 'Allineato al Curricolo',
    description: 'Costruito sulle Indicazioni Nazionali del MIUR, anno per anno.',
  },
]
